module.exports = __webpack_public_path__ + "media/asset/images/emoji-515fb1f4fd197c76e2301b7c5bc96c4c.png";